module.exports = __webpack_public_path__ + "static/media/yangyang-3.jpeg";